import { render } from "./ItemAdjustment_info.vue?vue&type=template&id=19c0e5d4"
import script from "./ItemAdjustment_info.vue?vue&type=script&lang=js"
export * from "./ItemAdjustment_info.vue?vue&type=script&lang=js"

import "./ItemAdjustment_info.vue?vue&type=style&index=0&id=19c0e5d4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__